import { Uuid } from "../../domain/model/uuid/uuid.type";

export class ApproveRejectRegService {

  constructor() { }

  rejectBatchInsertion(sectionId: Uuid, batchId: Uuid)  {
    console.debug(`rejectBatchInsertion sectionId=${sectionId.asString()}, batchId=${batchId.asString()}`);
  }


  approveBatchInsertion(sectionId: Uuid, batchId: Uuid) {
    console.debug(`approveBatchInsertion sectionId=${sectionId.asString()}, batchId=${batchId.asString()}`);
  }

}
